import { FC, useMemo } from "react"

import useTranslationsTenantLanguages from "./hooks/useTranslationsTenantLanguages"
import Translations, { ITranslationsProps } from "./Translations"

interface ITenantTranslationsProps extends ITranslationsProps {
    mandatoryTranslationIsoCodes?: string[]
    showAllPossibleLanguages?: boolean
    showOnlyRequiredLanguages?: boolean
    showLangTitle?: boolean
}

const TenantTranslations: FC<ITenantTranslationsProps> = ({
    showOnlyRequiredLanguages,
    showLangTitle,
    ...props
}) => {
    const {
        mandatoryTranslationIsoCodes,
        showAllPossibleLanguages,
    } = props

    const {
        languages,
        isTranslationOptional,
        isFirstOptionalLanguageAfterMandatoryLanguage,
    } = useTranslationsTenantLanguages({
        mandatoryTranslationIsoCodes,
        showAllPossibleLanguages,
    })

    const shownLanguages = useMemo(() => {
        if (!showOnlyRequiredLanguages) return languages
        return languages.filter(language => !isTranslationOptional(language.isoCode))
    }, [isTranslationOptional, languages, showOnlyRequiredLanguages])

    return (
        <Translations
            {...props}
            languages={shownLanguages}
            isTranslationOptional={isTranslationOptional}
            isFirstOptionalLanguageAfterMandatoryLanguage={isFirstOptionalLanguageAfterMandatoryLanguage}
            showLangTitle={showLangTitle}
        />
    )
}

export default TenantTranslations
